document.addEventListener('DOMContentLoaded', (event) => {
    document.addEventListener('click', fixMenuDropdownChevron);
    document.addEventListener('keydown', fixMenuDropdownChevron);

    function fixMenuDropdownChevron(e) {
        const btn = e.target.closest('.menu-list__chevron');
        if (!btn) return;

        if (
            e.type === 'click' ||
            (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))
        ) {
            e.preventDefault();
            const headerMenu = document.querySelector('header-menu')
            const expanded = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', String(!expanded));

            const overflowList = btn
            .closest('overflow-list')
            ?.shadowRoot
            ?.querySelector('[part="overflow"]');

            overflowList?.toggleAttribute('hidden', expanded);

            if(!expanded) {
                headerMenu.style.setProperty('--submenu-height', '247px');
                headerMenu.style.setProperty('--submenu-opacity', '1');

                const parent =  btn.closest('.menu-parent-ada');
                const next = parent.nextElementSibling;
                if(next) {
                    next.style.visibility = 'visible';
                }
            } else {
                headerMenu.style.setProperty('--submenu-height', '0px');
                headerMenu.style.setProperty('--submenu-opacity', '0');

                const parent =  btn.closest('.menu-parent-ada');
                const next = parent.nextElementSibling;
                if(next) {
                    next.style.visibility = 'hidden';
                }
            }
        }

        if(e.type === 'keydown' && (e.key === 'Escape')) {
            e.preventDefault();
            btn.click();
        }
    }


    function fixProductThumbnails(root = document) {
        const update = (titleLink, listitem) => {
            listitem.setAttribute('data-a11y-fixed', 'true');
            const newIdValue = Math.random().toString(36).slice(2, 10);
            const price = listitem.querySelector('product-price');
            const badges = listitem.querySelector('.product-badges');

            if (!price || !badges) return;

            titleLink.id = `title_id_${newIdValue}`;
            price.id = `price_id_${newIdValue}`;
            badges.id = `badges_id_${newIdValue}`;

            titleLink.setAttribute(
                'aria-describedby',
                `${price.id} ${badges.id}`
            );

            listitem.querySelectorAll('.ATC_BTN').forEach(btnATC => {
                btnATC.setAttribute('aria-describedby', titleLink.id);
            });
        };


        root.querySelectorAll('product-card:not([data-a11y-fixed])')
            .forEach(listitem => {

            const titleLink = listitem.querySelector('.user-select-text');
            update(titleLink, listitem);

            new MutationObserver(() => {
                if(!titleLink.getAttribute('aria-describedby')) {
                    update(titleLink, listitem);
                }
            }).observe(titleLink, {
                attributes: true,
                attributesFilter: ['aria-describedby']
            });
        });
    }
    const productObserver = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            mutation.addedNodes.forEach(node => {
            if (!(node instanceof Element)) return;

            // If a product-card itself is added
            if (node.matches('product-card')) {
                fixProductThumbnails();
            }

            // If products are added inside another container
            const cards = node.querySelectorAll?.('product-card');
            if (cards?.length) {
                fixProductThumbnails();
            }
            });
        }
    });
    // initial run
    fixProductThumbnails();

    // observe future changes
    productObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    function getFocusableElements(container) {
        return Array.from(
            container.querySelectorAll(
            "summary, a[href], button, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
            ),
        );
    }

    const trapFocusHandlers = {};
    function removeTrapFocus(elementToFocus = null) {
        document.removeEventListener("focusin", trapFocusHandlers.focusin);
        document.removeEventListener("focusout", trapFocusHandlers.focusout);
        document.removeEventListener("keydown", trapFocusHandlers.keydown);

        if (elementToFocus) elementToFocus.focus();
    }
    function trapFocus(container, elementToFocus = container) {
        var elements = getFocusableElements(container);
        var first = elements[0];
        var last = elements[elements.length - 1];

        removeTrapFocus();

        trapFocusHandlers.focusin = (event) => {
            if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
            )
            return;

            document.addEventListener("keydown", trapFocusHandlers.keydown);
        };

        trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        };

        trapFocusHandlers.keydown = function (event) {
            if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
            // On the last focusable element and tab forward, focus the first element.
            if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
            }

            //  On the first focusable element and tab backward, focus the last element.
            if (
            (event.target === container || event.target === first) &&
            event.shiftKey
            ) {
            event.preventDefault();
            last.focus();
            }
        };

        document.addEventListener("focusout", trapFocusHandlers.focusout);
        document.addEventListener("focusin", trapFocusHandlers.focusin);

        elementToFocus.focus();

        if (
            elementToFocus.tagName === "INPUT" &&
            ["search", "text", "email", "url"].includes(elementToFocus.type) &&
            elementToFocus.value
        ) {
            elementToFocus.setSelectionRange(0, elementToFocus.value.length);
        }
    }
    // Focus trap filter collection
    document.addEventListener("click", (event) => {
        const toggle = event.target.closest(".facets-toggle__button");
        if (!toggle) return;
        const dialog = document.querySelector("#filters-drawer");
        if (!dialog) return;
        const btn = dialog.querySelector(".facets-drawer__close")
        trapFocus(dialog, btn);
    });
    // Focus trap shopping cart
    document.addEventListener("click", (event) => {
        const toggle = event.target.closest(".cart-open");
        if (!toggle) return;
        const dialog = document.querySelector(".cart-drawer__dialog");
        if (!dialog) return;
        const btn = dialog.querySelector(".cart-drawer__close-button");
        trapFocus(dialog, btn);
    });

    function addingExtraDescriptionToProductPageActions() {
        if(!window.location.pathname.includes('/products')) return;

        const titleLink = document.querySelector('.group-block-content .user-select-text');
        if(titleLink) {
            const h1 = document.createElement('h1');
            titleLink.parentNode.insertBefore(h1, titleLink);
            h1.appendChild(titleLink);
            h1.style.marginBottom = '0';

            titleLink.id = 'Feature_product_id';
            titleLink.tabIndex = '-1';
            document.querySelectorAll('quantity-selector-component button, quantity-selector-component input, .product-form-buttons .ATC_BTN').forEach(item => {
                item.setAttribute('aria-describedby', titleLink.id);
            });
        }
    }

    addingExtraDescriptionToProductPageActions();

    function replaceHeadingSearch() {
        if(!window.location.pathname.includes('/search')) return;
        const oldTile = document.querySelector('h3');

        if(oldTile) {
            const h1 = document.createElement('h1');
            h1.innerText = oldTile.innerText;
            oldTile.replaceWith(h1);
        }
    }

    replaceHeadingSearch();

    function replaceHeadingCollection() {
        if(!window.location.pathname.includes('/collections')) return;
        const oldTile = document.querySelector('.h2 p');

        if(oldTile) {
            const h1 = document.createElement('h1');
            h1.innerText = oldTile.innerText;
            oldTile.replaceWith(h1);
        }
    }

    replaceHeadingCollection();

    function fixReviewStars() {
        const updateLooxAria = (root = document) => {
            root.querySelectorAll('.loox-rating').forEach(el => {
                if (el.dataset.ariaFixed) return;

                const rating = el.getAttribute('data-rating');
                const count = el.getAttribute('data-raters');

                if (rating && count) {
                    setTimeout(() => {
                        el.setAttribute('aria-label', `${rating} out of 5 stars from ${count} reviews`);
                        el.removeAttribute('title');
                    }, 1000);
                    el.dataset.ariaFixed = 'true';
                }


            });
        };

        updateLooxAria();
        const observer = new MutationObserver(mutations => {
            for (const m of mutations) {
                m.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;

                if (node.matches?.('.loox-rating')) {
                    updateLooxAria(node.parentNode);
                } else if (node.querySelector?.('.loox-rating')) {
                    updateLooxAria(node);
                }
                });
            }
            });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

    }

    fixReviewStars();

    function fixHeaderActions() {
        const headerActions = document.querySelector('.header__column:has(.account-button)');
        if(!headerActions) return;
        setTimeout(() => {
            headerActions.setAttribute('role', 'navigation');
            headerActions.setAttribute('aria-label', 'User actions');
        }, 1000);
    }

    fixHeaderActions();

    function addBtnToVideo() {
        const wrapper = document.querySelector('.hero__media-wrapper');
        if(!wrapper) return;
        const video = wrapper.querySelector('.hero__video');
        const btn = wrapper.querySelector('.hero__video-control');
        btn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                btn.textContent = '❚❚';
                btn.setAttribute('aria-label', 'Pause video');
                btn.setAttribute('aria-pressed', 'true');
            } else {
                video.pause();
                btn.textContent = '▶';
                btn.setAttribute('aria-label', 'Play video');
                btn.setAttribute('aria-pressed', 'false');
            }
        });
    }

    addBtnToVideo();

    function sliderOnMobile() {
        if(window.innerWidth < 768) {
            document.querySelectorAll('.reyr-product-grid, .reyr-accessories-grid').forEach(container => {
                container.setAttribute('role', 'region');
                const slides = container.querySelectorAll('.reyr-product-card-link, .reyr-accessory-card-link');
                slides.forEach((slide, index) => {
                    slide.setAttribute('role', 'group');
                    slide.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`)
                });

                appendSliderArrows(slides, container);
                intersectionObserverAda(slides, container);
            });
        }
    }

    sliderOnMobile();


    function appendSliderArrows(slides, wrapperContainer) {
        /* --------------------
            Create arrows
        --------------------- */
        const controls = document.createElement('div');
        controls.className = 'tent-slider-controls';
        controls.setAttribute('role', 'group');
        controls.setAttribute('aria-label', 'Slider controls');

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'tent-slider-prev';
        prevBtn.setAttribute('aria-label', 'Previous slide');
        prevBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        `;

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'tent-slider-next';
        nextBtn.setAttribute('aria-label', 'Next slide');
        nextBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        `;

        controls.append(prevBtn, nextBtn);
        wrapperContainer.after(controls);
        let currentIndex = 0;

        function moveTo(index) {
            currentIndex = Math.max(0, Math.min(index, slides.length - 1));

            slides[currentIndex].scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest'
            });
        }

        prevBtn.addEventListener('click', () => moveTo(currentIndex - 1));
        nextBtn.addEventListener('click', () => moveTo(currentIndex + 1));
    }

    function intersectionObserverAda(slides, parent, visibilityPercentage = 0.9) {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    const isVisible = entry.intersectionRatio >= visibilityPercentage;
                    entry.target.setAttribute(
                    'aria-hidden',
                    isVisible ? 'false' : 'true'
                    );

                    entry.target.querySelectorAll('a, button').forEach(element => {
                        element.setAttribute('tabindex', isVisible ? '0' : '-1');
                    });
                });
            },
            {
            root: parent,
            threshold: [visibilityPercentage]
            }
        );

        slides.forEach(slide => observer.observe(slide));
    }
})